/**
 * возможность легко применять один из class к body
 */
import {Widget} from "base/assets/js/widget/Widget.js";
import {LayoutScroll} from "base/assets/js/widget/LayoutScroll.js";
import {Sb} from "base/assets/js/widget/Sb.js";

export class BodyMode extends Widget {

	aModesAvail = [
		['body_leftbar'],
	];
	bOverlayClickReset = true;

	_aModes = [];
	run() {

		this._on( 'Btn[]?', 'click', ( oEvent ) => {
			oEvent.preventDefault();
			let sMode = this._attr( oEvent.currentTarget, 'mode' );
			this.setMode( sMode );
		} );
		if ( this.bOverlayClickReset ) {
			this._on( 'Overlay', 'click', ( oEvent ) => {
				if ( oEvent.target !== this._el( 'Overlay' ) ) {
					return;
				}
				this.setMode( '' );
			} );
		}
	}

	getModes() {
		return this._aModes;
	}

	setMode( sMode, bValue = null ) {

		for ( let i in this.aModesAvail ) {
			const aModesAvailItem = this.aModesAvail[ i ];

			// не указан режим - по сути сброс
			if( !sMode ) {
				this._aModes = [];
				this._mod( '', aModesAvailItem, '' );
				continue;
			}

			// проверяем с каким режимом конфликтует, и устанавливаем там
			if ( aModesAvailItem.indexOf( sMode ) !== -1 ) {

				// добавляем или убираем из _aModes
				const iModeIndex = this._aModes.indexOf( sMode );
				if( bValue === null ) {
					if( iModeIndex === -1 ) {
						this._aModes.push( sMode );
					} else {
						this._aModes.splice( iModeIndex, 1 );
					}
				} else {
					if( bValue && iModeIndex === -1 ) {
						this._aModes.push( sMode );
					} else if( !bValue && iModeIndex !== -1 ) {
						this._aModes.splice( iModeIndex, 1 );
					}
				}


				// todo подумать над вариантом перенести логику в Widget
				let sNew = '';
				this._aModes.forEach( ( sEnabledMode ) => {
					if( aModesAvailItem.indexOf( sEnabledMode ) === -1 ) {
						return;
					}
					sNew = sEnabledMode;
				} )
				this._mod( '', aModesAvailItem, sNew );
				break;
			}
		}

		// если какой то режим включен, то скорлл выключаем
		this._getLayoutScroll().disable( this._aModes.length > 0 );
	}

	/**
	 * @return {LayoutScroll}
	 */
	_getLayoutScroll() {
		if( !this._oLayoutScroll ) {
			this._oLayoutScroll = this._rel().typeOf( LayoutScroll ).find();
		}
		return this._oLayoutScroll;
	}

	isShowOverlay() {
		return this._el( 'Overlay' ).offsetHeight > 0;
	}
}
